import { CalcStorageDaysService } from './../../services/calc-storage-days.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { DropDownListDTO, DropDownListSiteRecebimentoDTO } from 'src/app/entity/dto/dropdownlist.component';
import { GeneralComponent } from 'src/app/shared/general.component';
import { take } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxChange } from '@angular/material/checkbox';

export interface PeriodicElement { 
  position: number;
  lote: string;
  faixaGenetica: string;
  faixaFisiologica: string;
}

export interface OrdemPrioridadeSequenciamento {
  value: number;
  name: string;
}

@Component({
  selector: 'app-form-sequenceManage',
  templateUrl: './form-sequenceManage.component.html',
  styleUrls: ['./form-sequenceManage.component.scss']
})

export class FormSequenceManageComponent extends GeneralComponent implements OnInit {
  public formulario?: FormGroup;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public enableButtons = this.loadingSubject.asObservable();

  public listSiteRecebimento?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
  public listSiteRecebimentoOriginal?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
  public listSafra?: DropDownListDTO[];
  public listHibrido?: DropDownListDTO[];
  public listLoteDs?: any[];
  public listPeneiras?: any[];

  public listSafraOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listHibridoOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();
  public listLoteDsOriginal: Array<any> = new Array<any>();

  public listSec002Info?: any[];
  public listCd002Unicos?: any[];
  public orderedMarkedListByLote = [];
  public listLotesRegraSegragacao = [];
  public listFaixasFisiologica = [];
  public isMisturarTonsAzul: boolean = false;
  public isLoteSegragacaoSelecionado: boolean = false;
  public selectAllChecked: boolean = false;

  public isReadyOnly: boolean;

  public selectedSafraList = [];
  public selectedLoteList = [];
  public listPrioridadesSequenciamento: OrdemPrioridadeSequenciamento[] = [
    {value: 1, name: 'Defeitos em ordem crescente'},
    {value: 2, name: 'Defeitos em ordem decrescente'},
  ];
  public selectedPrioridadeSequenciamento = this.listPrioridadesSequenciamento[0].value;
  public enablePrioridadesSequenciamento = false;
  maxSelection = 24;
  public dataSourceByRegraSegregacao?: MatTableDataSource<any>;
  public displayedColumnsByRegraSegregacao?: string[] = ['select', 'Lotes', 'FaixaGenetica', 'FaixaFisiologica'];

  selection = new SelectionModel<PeriodicElement>(true, []);

  @Output() buildReport = new EventEmitter();

  // tslint:disable-next-line: max-line-length
  constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
    super('Gerar sequenciamento de lotes e orientações gerais', false);
  }

  public async ngOnInit(): Promise<void> {
    this.getFormulario();
    this.isReadyOnly = true;
    await this.getLists();

    this.loadingSubject.next(false);
  }

  getFormulario(): void {
    this.formulario = this.formBuilder.group({
      Site_recebimento: [null, []],
      Hibrido_rnc_linhagem: [null, []],
      Safra: [null, []],
      SafraSeracher: [null, []],
      Lote_ds: [{ value: null, disabled: true }, [Validators.maxLength(24)]],
      LoteSearcher: [null, []],
      Peneiras: [{ value: null, disabled: true }, []],
      PrioridadeSequenciamento: [{ value: null, disabled: false}, []],
      MisturarTonsAzul: [{ value: null }, []],
    });
  }

  async getLists(): Promise<void> {
    await Promise.all([
      this.getListSiteRecebimento(),
      this.getListSafra(),
    ]);
  }

  async getListSiteRecebimento(): Promise<void> {
    this.listSiteRecebimento = this.generalService.getListSiteRecebimento();
    this.listSiteRecebimentoOriginal = this.listSiteRecebimento;
  }

  async getListSafra(): Promise<void> {
    await this.formularioService.getListDropDownList('qua007', 'safra').pipe(take(1)).toPromise().then(response => {
      if (!!response?.data) {
        this.listSafra = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listSafraOriginal = this.listSafra;
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSafra);
    });
  }

  checkMaxSelection() {
    const selectedValues = this.formulario.get('Lote_ds').value || [];
    if (selectedValues.length > this.maxSelection) {
      this.formulario.get('Lote_ds').setValue(selectedValues.slice(0, this.maxSelection));
    }
  }

  async createFilterSafra(value?: string): Promise<void> {
    this.setSelectedValues('Safra', this.selectedSafraList);
    this.formulario.get('Safra').setValue(this.selectedSafraList);
    if (!!value && value.length > 0) {
      if (this.listSafraOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
        this.listSafra = this.listSafraOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
      } else
        this.listSafra = this.listSafraOriginal;
    } else {
      this.listSafra = this.listSafraOriginal;
    }
  }

  async getListHibrido(): Promise<void> {
    const safras = this.formulario.get('Safra')?.value;

    var safrasStr = '';
    safras.forEach(safra => {
      safrasStr += safra + ", ";
    })
    safrasStr = safrasStr.slice(0, -2);

    if(safras){
      await this.formularioService.getListHibridoBySafraWithLoteDs(safrasStr).pipe(take(1)).toPromise().then(response => {
        if (!!response?.data) {
          this.listHibrido = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
          this.listHibridoOriginal = this.listHibrido;
        }
      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorHibrido);
      });
    }else{
      this.listHibrido = null;
      this.listHibridoOriginal = this.listHibrido;
    }
  }

  async createFilterHibrido(value?: string): Promise<void> {
    if (!!value && value.length > 0) {
      if (
        this.listHibridoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        ).length > 0
      ) {
        this.listHibrido = this.listHibridoOriginal.filter((x) =>
          x.name?.toLowerCase().includes(value?.toLowerCase())
        );
      } else {
        this.listHibrido = this.listHibridoOriginal;
      }
    } else {
      this.listHibrido = this.listHibridoOriginal;
    }
  }

  async getListLoteDs(): Promise<void> {
    const hibrido = this.formulario.get('Hibrido_rnc_linhagem')?.value as string;
    const safras = this.formulario.get('Safra')?.value;

    this.selectedLoteList = [];
    this.formulario.get('Lote_ds').setValue(this.selectedLoteList);

    if (!!hibrido && !!safras && safras?.length > 0) {

      var safrasStr = '';
      safras.forEach(safra => {
        safrasStr += "'" + safra + "', ";
      })
      safrasStr = safrasStr.slice(0, -2);
      await this.formularioService.getLotesFromSec002Data(hibrido, safrasStr).pipe(take(1)).toPromise().then(response => {
        if (!!response?.data) {
          this.listLoteDs = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
          this.listLoteDsOriginal = this.listLoteDs;
          this.formulario.get('Lote_ds').enable({ onlySelf: true });
          this.formulario.get('MisturarTonsAzul').setValue("N");     
          this.resetarRegraSegregacao();
          this.enablePrioridadesSequenciamento = false;
        }
      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, `Ocorreu um Erro para buscar do banco de dados para montagem da lista de Lote Ds`);
      });
    }
  }

  async getListPeneiras(): Promise<void> {
    const lotes = this.formulario.get('Lote_ds')?.value;

    this.formulario.get('Peneiras').setValue(null);

    if (!!lotes && lotes?.length > 0) {

      var lotesStr = '';
      lotes.forEach(lote => {
        lotesStr += "'" + lote + "', ";
      })
      lotesStr = lotesStr.slice(0, -2);

      await this.formularioService.getPeneirasFromCd006Data(lotesStr).pipe(take(1)).toPromise().then(response => {
        if (!!response?.data) {
          response.data.forEach(obj => {
            obj.name = obj.c1_peneira + '-' + obj.c2_peneira + '-' + obj.c3_peneira;
          })

          this.listPeneiras = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
          this.formulario.get('Peneiras').enable({ onlySelf: true });
        }
      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, `Ocorreu um Erro para buscar do banco de dados para montagem da lista de Peneiras`);
      });
    }
  }

  async createFilterLoteDs(value?: string): Promise<void> {
    this.setSelectedValues('Lote_ds', this.selectedLoteList);
    this.formulario.get('Lote_ds').setValue(this.selectedLoteList);
    this.selectedLoteList.length > 0 ? this.enablePrioridadesSequenciamento = true : this.enablePrioridadesSequenciamento = false;
    if (!!value && value.length > 0) {
      if (this.listLoteDsOriginal.filter(x => x.lote_ds?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
        this.listLoteDs = this.listLoteDsOriginal.filter(x => x.lote_ds?.toLowerCase().includes(value?.toLowerCase()));
      } else {
        this.listLoteDs = this.listLoteDsOriginal;
        this.resetarRegraSegregacao();
      }
    } else {
      this.listLoteDs = this.listLoteDsOriginal;
      this.resetarRegraSegregacao();
    }
  }

  setSelectedValues(form: string, selectedValues: Array<any>) {
    const formValues = this.formulario.get(form).value;

    if (!!formValues && formValues.length > 0) {
      formValues.forEach((e) => {
        if (selectedValues.indexOf(e) == -1) {
          selectedValues.push(e);
        }
      });
    }
  }

  async selectionSafraChange(event: any) {
    await this.getListLoteDs();
    await this.getListHibrido();
  }

  async selectionHibridoChange(event: any) {
    await this.getListLoteDs();
  }

  toggleSelectAll(): void {
    this.selectAllChecked = !this.selectAllChecked;
  
    if (this.selectAllChecked) {
      this.listLoteDs.forEach(item => {
        if (!this.selectedLoteList.includes(item.lote_ds)) {
          this.selectedLoteList.push(item.lote_ds);
        }
      });
    } else {
      this.selectedLoteList = [];
    }
  
    this.formulario.controls['Lote_ds'].setValue(this.selectedLoteList);
  }

  async selectionLoteChange(event: any) {
    const hibrido = this.formulario.get('Hibrido_rnc_linhagem')?.value as string;
    const lotes = this.formulario.get('Lote_ds')?.value as string;

    if (!!hibrido && !!lotes && lotes?.length > 0) {
      if(lotes.length > 0){
        var lotesStr = '';
        this.selectedLoteList.forEach(lote => {
          lotesStr += "'" + lote + "', ";
        })
        lotesStr = lotesStr.slice(0, -2);
        this.getListSec002(lotesStr);
      }
      if (hibrido.endsWith('4')) {
        await this.getListPeneiras();

      }
      else {
        this.formulario.get('Peneiras').setValue(null);
        this.formulario.get('Peneiras').disable({ onlySelf: true });
      }
    }
    else {
      this.formulario.get('Peneiras').setValue(null);
      this.formulario.get('Peneiras').disable({ onlySelf: true });
    }
  }

  async openedChangeSafra(event: any, fieldSearcher?: string,) {
    this.formulario.get(fieldSearcher).setValue('');
    await this.createFilterSafra(undefined);
  }

  async openedChangeLote(event: any, fieldSearcher?: string,) {
    this.formulario.get(fieldSearcher).setValue('');
    await this.createFilterLoteDs(undefined);
    await this.selectionLoteChange(event);
  }

  selectionChange(event: any, selectedValues?: Array<any>) {
    this.setSelectedValues('Lote_ds', this.selectedLoteList);
    if (event.source.selected == true) {
      if(this.selectedLoteList.length > 0){
        var lotesStr = '';
        this.selectedLoteList.forEach(lote => {
          lotesStr += "'" + lote + "', ";
        })
        lotesStr = lotesStr.slice(0, -2);
      }
    }
    if (event.isUserInput && event.source.selected == false) {
      let index = selectedValues.indexOf(event.source.value);
      selectedValues.splice(index, 1)
    }
  }

  async buildReports(event: any): Promise<void> {
    this.buildReport.emit({ event: event });
  }

  async getListSec002(lotesStr: string): Promise<void> {
    await this.formularioService.getInfoFromSec002DataByLotes(lotesStr).pipe(take(1)).toPromise().then(response => {
      if (!!response?.data) {
        this.listSec002Info = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listCd002Unicos = this.removerRepetidos(this.listSec002Info);
        this.getFaixasDeQualidade(this.listCd002Unicos);
        var tabela = [];
        var tabelaFaixas = [];
        for (let i = 0; i < this.listCd002Unicos.length; i++) {
          tabelaFaixas = this.listCd002Unicos.filter((x) => x.faixas_qual?.toLowerCase() !== '');
          if (tabelaFaixas[i] != null) {
            tabela.push(Object.assign({}, tabelaFaixas[i]));
          }
      }
      this.dataSourceByRegraSegregacao = new MatTableDataSource<PeriodicElement>(tabela);
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, `Ocorreu um Erro para buscar do banco de dados para informações da Sec002`);
    });
  }

  getFaixasDeQualidade(values: Array<any>): void {
    values.forEach(element => {
      const secInfos = this.listSec002Info.filter(secValue => ((secValue.lote_ds === element.lote_ds)));
      let faixasGeneticaValue = '';
      let faixasFisiologicaValue = '';
      let abriuParenteses = false; // Controle para abrir parêntese apenas uma vez
  
      if (secInfos.length > 0) {
        secInfos.forEach(secInfo => {
          // Lógica para faixas fisiológicas
          if ((!!secInfo.faixa_azul_campo && !secInfo.faixa_azul_campo.toUpperCase().includes('SEM'))
            || (!!secInfo.faixa_azul_umidade_de_colheita && secInfo.faixa_azul_umidade_de_colheita.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_temperatura_de_secagem && secInfo.faixa_azul_temperatura_de_secagem.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_sem_vapor_ou_ventilacao && secInfo.faixa_azul_sem_vapor_ou_ventilacao.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_ressecagem && secInfo.faixa_azul_ressecagem.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_transbordo && secInfo.faixa_azul_transbordo.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_claro_temperatura_carga && secInfo.faixa_azul_claro_temperatura_carga.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_claro_tempo_de_patio && secInfo.faixa_azul_claro_tempo_de_patio.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_escuro_temperatura_carga && secInfo.faixa_azul_escuro_temperatura_carga.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_escuro_tempo_de_patio && secInfo.faixa_azul_escuro_tempo_de_patio.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_escuro_granel_tempo_de_transporte && secInfo.faixa_azul_escuro_granel_tempo_de_transporte.toUpperCase() === 'SIM')
          ) {
            if (!abriuParenteses) {
              faixasFisiologicaValue += 'Azul(';
              abriuParenteses = true;
            }
            if (!!secInfo.faixa_azul_campo && !secInfo.faixa_azul_campo.toUpperCase().includes('SEM') && !faixasFisiologicaValue.toUpperCase().includes(secInfo.faixa_azul_campo.toUpperCase())) {
              faixasFisiologicaValue += faixasFisiologicaValue.includes('Campo') ? secInfo.faixa_azul_campo + ' ' : 'Campo - ' + secInfo.faixa_azul_campo + ' ';
            }
            if (!!secInfo.faixa_azul_umidade_de_colheita && secInfo.faixa_azul_umidade_de_colheita.toUpperCase() === 'SIM' && !faixasFisiologicaValue.includes('Umidade de colheita'))
              faixasFisiologicaValue += 'Umidade de colheita ';
            if (!!secInfo.faixa_azul_temperatura_de_secagem && secInfo.faixa_azul_temperatura_de_secagem.toUpperCase() === 'SIM' && !faixasFisiologicaValue.includes('Temperatura de Secagem'))
              faixasFisiologicaValue += 'Temperatura de Secagem ';
            if (!!secInfo.faixa_azul_sem_vapor_ou_ventilacao && secInfo.faixa_azul_sem_vapor_ou_ventilacao.toUpperCase() === 'SIM' && !faixasFisiologicaValue.includes('Sem Vapor ou Ventilação'))
              faixasFisiologicaValue += 'Sem Vapor ou Ventilação ';
            if (!!secInfo.faixa_azul_ressecagem && secInfo.faixa_azul_ressecagem.toUpperCase() === 'SIM' && !faixasFisiologicaValue.includes('Ressecagem'))
              faixasFisiologicaValue += 'Ressecagem ';
            if (!!secInfo.faixa_azul_transbordo && secInfo.faixa_azul_transbordo.toUpperCase() === 'SIM' && !faixasFisiologicaValue.includes('Transbordo'))
              faixasFisiologicaValue += 'Transbordo ';
            if (!!secInfo.faixa_azul_claro_temperatura_carga && secInfo.faixa_azul_claro_temperatura_carga.toUpperCase() === 'SIM' && !faixasFisiologicaValue.includes('Temperatura - Claro'))
              faixasFisiologicaValue += 'Temperatura - Claro ';
            if (!!secInfo.faixa_azul_claro_tempo_de_patio && secInfo.faixa_azul_claro_tempo_de_patio.toUpperCase() === 'SIM' && !faixasFisiologicaValue.includes('Tempo de Pátio - Claro'))
              faixasFisiologicaValue += 'Tempo de Pátio - Claro ';
            if (!!secInfo.faixa_azul_escuro_temperatura_carga && secInfo.faixa_azul_escuro_temperatura_carga.toUpperCase() === 'SIM' && !faixasFisiologicaValue.includes('Temperatura - Escuro'))
              faixasFisiologicaValue += 'Temperatura - Escuro ';
            if (!!secInfo.faixa_azul_escuro_tempo_de_patio && secInfo.faixa_azul_escuro_tempo_de_patio.toUpperCase() === 'SIM' && !faixasFisiologicaValue.includes('Tempo de Pátio - Escuro'))
              faixasFisiologicaValue += 'Tempo de Pátio - Escuro ';
            if (!!secInfo.faixa_azul_escuro_granel_tempo_de_transporte && secInfo.faixa_azul_escuro_granel_tempo_de_transporte.toUpperCase() === 'SIM' && !faixasFisiologicaValue.includes('Granel Tempo de Transporte - Escuro'))
              faixasFisiologicaValue += 'Granel Tempo de Transporte - Escuro ';
          }
        });
  
        // Fecha o parêntese se aberto
        if (abriuParenteses) {
          faixasFisiologicaValue = faixasFisiologicaValue.trim() + ')';
        }
  
        // Lógica para faixas genéticas
        secInfos.forEach(secInfo => {
          if (!!secInfo.faixa_vermelha && secInfo.faixa_vermelha.toUpperCase() === 'SIM' && !faixasGeneticaValue.includes('Vermelha'))
            faixasGeneticaValue += 'Vermelha ';
          if (!!secInfo.faixa_roxa && secInfo.faixa_roxa.toUpperCase() === 'SIM' && !faixasGeneticaValue.includes('Roxa'))
            faixasGeneticaValue += 'Roxa ';
          // if (!!secInfo.faixa_marrom && secInfo.faixa_marrom.toUpperCase() === 'SIM' && !faixasGeneticaValue.includes('Marrom'))
          //   faixasGeneticaValue += 'Marrom ';
        });
  
        // Atribuição final
        if (faixasGeneticaValue.length > 0 || faixasFisiologicaValue.length > 0) {
          element['faixas_qual'] = (faixasGeneticaValue + faixasFisiologicaValue).trim();
          element['faixa_genetica'] = faixasGeneticaValue.trim();
          element['faixa_fisiologica'] = faixasFisiologicaValue.trim();
        } else {
          element['faixas_qual'] = '';
          element['faixa_genetica'] = '';
          element['faixa_fisiologica'] = '';
        }
      }
    });
  }
  

  removerRepetidos(values: Array<any>): Array<any> {
    var repeated = values
      .map(e => e['lote_ds'])
      .map((e, i, final) => final.indexOf(e) !== i && i)
      .filter(obj => values[obj])
      .map(e => values[e]["lote_ds"]);

    if (repeated.length > 0) {
      repeated.forEach(element => {
        var duplicates = values.filter(obj => element === obj.lote_ds);
        var maxValue = duplicates.reduce((prev, curr) => {
          return (prev.volume_ds >= curr.volume_ds) ? prev : curr;
        });

        values = values.filter(obj => !((obj.lote_ds === maxValue.lote_ds) && (obj.contrato_juridico !== maxValue.contrato_juridico)));
      });
    }
    var repeated = values
      .map(e => e['lote_ds'])
      .map((e, i, final) => final.indexOf(e) !== i && i)
      .filter(obj => values[obj])
      .map(e => values[e]["lote_ds"]);

    if (repeated.length > 0) {
      repeated.forEach(element => {
        var maxValue = values.find(obj => element === obj.lote_ds);

        values = values.filter(obj => !((obj.lote_ds === maxValue.lote_ds) && (obj.contrato_juridico === maxValue.contrato_juridico) && (obj !== maxValue)));
      });
    }
    return values;
  }

  formatFaixasFisiologica(value: any): string {
    if (value.faixa_fisiologica.includes('Escuro'))
      return 'color-faixa-azul-escuro';
    else if (value.faixa_fisiologica.includes('Campo'))
      return 'color-faixa-azul-campo-planta';
    else if (value.faixa_fisiologica.includes('Ressecagem') || value.faixa_fisiologica.includes('Umidade de colheita') 
      || value.faixa_fisiologica.includes('Temperatura de Secagem') || value.faixa_fisiologica.includes('Sem Vapor ou Ventilação')
      || value.faixa_fisiologica.includes('Transbordo'))
      return 'color-faixa-azul-campo-planta';
    else if (value.faixa_fisiologica.includes('Claro'))
      return 'color-faixa-azul-claro';
    return null;
  }

  formatFaixasGenetica(value: any): string {
    if (value.faixa_genetica.includes('Vermelha'))
      return 'color-faixa-vermelho';
    else if (value.faixa_genetica.includes('Roxa'))
      return 'color-faixa-roxa';
    else if (value.faixa_genetica.includes('Marrom'))
      return 'color-faixa-marrom';
    return null;
  }

  verificarLotesRegraSegragacao(event: MatCheckboxChange, lote:MatCheckboxChange, faixaFisiologica:string): void {
    this.isLoteSegragacaoSelecionado = event.checked;
    var indice = this.listLotesRegraSegragacao.indexOf(lote);
    indice < 0 ? this.listLotesRegraSegragacao.push(lote) : this.listLotesRegraSegragacao.splice(indice, 1);

    if(faixaFisiologica !== "" && faixaFisiologica !== undefined)
      this.verificarMisturaTonsAzul(faixaFisiologica);
  }

  verificarMisturaTonsAzul(faixaFisiologica: string): void {
    if(this.isLoteSegragacaoSelecionado)
      this.listFaixasFisiologica.push(faixaFisiologica);
    else {
      var indiceLote = this.listFaixasFisiologica.indexOf(faixaFisiologica);
      this.listFaixasFisiologica.splice(indiceLote, 1);
    }

    const uniqueValues = new Set(this.listFaixasFisiologica);
    uniqueValues.size > 1 ? this.isMisturarTonsAzul = true : this.isMisturarTonsAzul = false;
  }

  resetarRegraSegregacao(): void {
    this.listFaixasFisiologica = [];
    this.isMisturarTonsAzul = false;
  }
}
